import { useEffect, useContext } from 'react';
import { changeWebPageTitleService } from '../../../infrastructure/services';
import { Private_Routes } from '../../../main/constants';
import { AppContext } from '../../../main/context/Provider';
import { EmployeeForm } from '../components/form/EmployeeForm';

export const CreateEmployeePage = () => {
    const { setNestedRoutes, isSkinSmart, lang } = useContext(AppContext);

    const { webPage } = changeWebPageTitleService(isSkinSmart, 'Nuevo Empleado');

    useEffect(() => {
        setNestedRoutes([
            {
                label: 'Empleados',
                route: Private_Routes.EMPLOYEE_PAGE,
            },
            {
                label: webPage,
                route: Private_Routes.CREATE_EMPLOYEE_PAGE,
            },
        ]);
    }, [lang]);

    return <EmployeeForm isNewEmployee={true} />;
};
